import { FC } from "react";
import { Row } from "../../containers";
import {
  DateInput,
  FileInput,
  NumberInput,
  SelectorInput,
  TextInput,
} from "../../inputs";
import { Bank } from "../../../types";
import { BANKS } from "../../../constants";
import { AlignItems } from "../../containers/types";
import { Button } from "../../buttons";
import { useThemeStore } from "../../../stores";
import { ChequeFormProps } from "./types";

const ChequeForm: FC<ChequeFormProps> = ({
  account_no,
  bank,
  date,
  name,
  number,
  price,
  shenase,
  file,
  setAccountNo,
  setBank,
  setDate,
  setName,
  setNumber,
  setPrice,
  setShenase,
  setFile,
  buttons = [],
  onDelete = () => {},
  onNext = () => {},
  onSubmit = () => {},
  readOnly = false,
}) => {
  const theme = useThemeStore((s) => s.theme);

  return (
    <>
      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <TextInput
          label="نام طرف حساب"
          value={name}
          setValue={setName}
          inputProps={{ readOnly }}
        />
        <TextInput
          label="شماره چک"
          value={number}
          setValue={setNumber}
          inputProps={{ readOnly }}
        />
        <TextInput
          label="شناسه"
          value={shenase}
          setValue={setShenase}
          inputProps={{ readOnly }}
        />
      </Row>
      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <DateInput
          date={date}
          setDate={setDate || (() => {})}
          label="تاریخ"
          readOnly={readOnly}
        />
        <SelectorInput<Bank>
          items={BANKS}
          label="بانک"
          selected={bank}
          setSelected={setBank || (() => {})}
          compareFn={(b, v) => b.fa.toLowerCase().includes(v.toLowerCase())}
          stringField={"fa"}
          uniqueKey={"name"}
          renderStrings={["fa"]}
          readOnly={readOnly}
        />
        <TextInput
          label="شماره حساب"
          value={account_no}
          setValue={setAccountNo}
          inputProps={{ readOnly }}
        />
      </Row>
      <Row
        gap={20}
        className="finance-input-row-2"
        style={{ width: "100%" }}
        alignItems={AlignItems.End}
      >
        <NumberInput
          label="مبلغ (ریال)"
          value={price}
          setValue={setPrice || (() => {})}
          price
          inputProps={{ readOnly }}
        />
        {!readOnly ? (
          <FileInput
            label="عکس چک"
            value={file}
            setValue={setFile || (() => {})}
          />
        ) : (
          <></>
        )}
        {!readOnly ? (
          <Row
            style={{ width: "100%", height: 41 }}
            gap={20}
            className="finance-input-row-3"
          >
            {buttons.includes("next") ? (
              <Button
                onClick={onNext}
                background={theme.secondary}
                color={theme.textonSecondary}
              >
                بعدی
              </Button>
            ) : (
              <></>
            )}
            {buttons.includes("submit") ? (
              <Button
                onClick={onSubmit}
                background={theme.primary}
                color={theme.textOnprimary}
              >
                ثبت
              </Button>
            ) : (
              <></>
            )}
            {buttons.includes("delete") ? (
              <Button
                onClick={onDelete}
                background={theme.alert}
                color={theme.textOnAlert}
              >
                حذف این چک
              </Button>
            ) : (
              <></>
            )}
          </Row>
        ) : (
          <></>
        )}
      </Row>
    </>
  );
};

export default ChequeForm;
